import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Layout, Row, Col, Tooltip } from "antd";
import { withRouter } from "react-router-dom";
import Wrapper from "../../components/wrapper";
import Loader from "../../components/loader";
import { StopOutlined } from "@ant-design/icons";
import { getDatasetsRefresh } from "../../slicers/datasets.slicer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import line532 from "../../assets/images/line532.png";
import ellipse151 from "../../assets/images/ellipse151.png";
import arrow1 from "../../assets/images/arrow1.png";
import "../styling/home.scss";

const { Content } = Layout;

const Home = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDatasetsRefresh());
  }, []);
  const { app_role_home } = useSelector((state) => state.hometab);
  const { loading, datasetData } = useSelector((state) => state.datasets);
  const text = <span>No access to this page</span>;
  // Again deploying the commented code for testing on 29-may-2026 as requested by backend team
  //function for showing data cards
  // On 01-08-2026 we are testing the tool again.
  function DataCard({ name, data, oppositeRole }) {
    return data.map(
      (info) =>
        info.dataset_name.toLowerCase() === name && (
          <div className="data-tab">
            <Row className="data-header">{info.dataset_name}</Row>
            <Row className="data-details">
              Last refreshed on: {info.refresh_date}
            </Row>
            <Row className="data-details">
              Latest Period Available: {info.up_to_year_period}
            </Row>
            <Row className="data-details">Data Owner: {info.data_owner}</Row>

            {app_role_home === `${oppositeRole}` ? (
              <Row className="stop-outlined">
                <Tooltip placement="bottom" title={text}>
                  <StopOutlined />
                </Tooltip>
              </Row>
            ) : (
              <Row
                className="ellipse-arrow"
                onClick={() => props.history.push(`/${name}`)}
              >
                <span className="ellipse-151-vector">
                  <img src={ellipse151} style={{ width: "37", height: "37" }} />
                </span>
                <span className="arrow-1-vector">
                  <img src={arrow1} style={{ width: "20", height: "5" }} />
                </span>
              </Row>
            )}
          </div>
        )
    );
  }
  return (
    <Wrapper heading={"0"}>
      <Content className="site-layout-background content-home-page">
        <Loader loading={loading > 0}>
          <div>
            <span className="header">Select Data Source to download</span>
            <span className="divider-line">
              <img src={line532} />
            </span>

            <span className="nielsen-data-card">
              <Col md={8}>
                <DataCard
                  name={"nielsen"}
                  data={datasetData}
                  oppositeRole={"Read.Epos"}
                />
              </Col>
            </span>
            {
              app_role_home === "Tool.Admin" &&
              <span className="epos-data-card">
                <Col md={8}>
                  <DataCard
                    name={"epos"}
                    data={datasetData}
                    oppositeRole={"Read.Nielsen"}
                  />
                </Col>
              </span>
            }
            <ToastContainer />
          </div>
        </Loader>
      </Content>
    </Wrapper>
  );
};

export default withRouter(Home);
